<template>
  <div>
    <modal-header>Broadcast</modal-header>

      <div class="broadcast-form__form ">
      <form enctype="multipart/form-data">
        <div class="form-group">
          <inputfield :value="title" @input="setBroadcastTitle"
          placeholder="Title (Mandatory)"/>
          <span class="error" v-if="titleError.length > 0">{{ titleError }}</span>
        </div>
        <div class="form-group msgGroup">
          <inputarea
            class="margin-sm-top"
            placeholder="Message (Optional. 200 chars max)"
            :inputValue="message" @keyPressing="setBroadcastMessage"/>
          <span class="error" v-if="msgError">{{ msgError }}</span>
          <span class="count">{{ msgCount }}/200</span>
        </div>

      </form>
    </div>

    <btn class="broadcast-preview" :customClasses="['text-white','bg-green']" @submit.prevent @onClick="previewBroadcast()">
      <template #text>Preview</template>
    </btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import ModalHeader from '@/framework/modals/components/newModalHeader.vue'

export default {
  components: { ModalHeader },
  name: 'BroadcastForm',
  data() {
    return {
      title: '',
      message: '',
      titleError: '',
      msgError: '',
    };
  },
  computed: {
    msgCount() {
      return this.message.length ? this.message.length : 0;
    }
  },
  watch:{
    title(newVal,oldVal){
      const maxTitleLength = 40;
      if(newVal.length > maxTitleLength){
        this.titleError = `Maximum title length is ${maxTitleLength}`;
        return this.title = oldVal;
      }
      if(this.title.length < maxTitleLength && this.titleError !== ''){
        this.titleError = ''
      }
      this.title = newVal;
    }
  },
  methods: {
    ...mapActions(['popups/notifications/confirmAddBroadcast', 'createBroadcast', 'modal/close']),
    setBroadcastMessage(evt){
      this.message = evt.target.value
    },
    setBroadcastTitle(val){
      this.title = val
    },
    verifyForm() {
      if(this.message.length > 200) {
        this.msgError = 'Message too long. Max 200 chars.';
        return false;
      }
      return true;
    },
    previewBroadcast() {
      if(this.verifyForm()) {
        this.$root.$emit('setBroadcastData', this.title, this.message)
        this['popups/notifications/confirmAddBroadcast']({data:this.submitForm(), submitForm: this.sendBroadcast})
      }
    },
    submitForm() {
      if(this.verifyForm()) {
        let formData = {
          title: this.title,
          message: this.message
        };
        return formData;
      }
    },
    sendBroadcast(){
      this.createBroadcast(this.submitForm());
      this['modal/close']();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/scss/components/modals/broadcast_form.scss';
</style>
